import axios from "./axiosConfig";

/**
 * @deprecated Este servicio está deprecated. Por favor usa eventsService en su lugar.
 * Este servicio ahora redirige a los endpoints de events para mantener compatibilidad.
 */
const servicesService = {
  getAll(params = {}) {
    const { year, month } = params;
    if (year && month) {
      return axios.get(`/events/calendar/${year}/${month}`);
    }
    return axios.get("/events");
  },

  getById(id) {
    return axios.get(`/services/${id}`);
  },

  create(data) {
    return axios.post("/services", data);
  },

  update(id, data) {
    return axios.put(`/services/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/events/${id}`);
  },

  getCalendar(month, year) {
    return axios.get(`/events/calendar/${year}/${month}`).then((res) => {
      // res.data debe ser el array de eventos según tu backend
      const events = res.data.data || []; 
      events.sort((a, b) => String(a.hour || "").localeCompare(String(b.hour || "")));
      return { data: { data: events } }; // mismo formato que el resto del código
    });
  },

  getRecurrenceOverview(params = {}) {
    return axios.get("/events/recurrence/overview", { params });
  },

  syncRecurrence(payload = {}) {
    return axios.post("/events/recurrence/sync", payload);
  },

  repeatCalendar({ fromMonth, toMonth, mode } = {}) {
    return axios.post("/events/repeat-calendar", {
      fromMonth,
      toMonth,
      mode,
    });
  },
};

export default servicesService;
